import React, { useEffect, useMemo } from 'react';
import { Source, Layer, useMap } from 'react-map-gl/maplibre';
import { useSelection } from '../../contexts/SelectionContext';
import { isReadingSelectionFor, findReadingFeature } from './pseudosection-helpers';

/**
 * Map side of the pseudosection link: rings the reading picked in the pseudosection panel (or
 * on the map) on the dataset's pseudosection layer, and centres the map on it when the pick
 * came from the panel. Reads SelectionContext: { type: 'reading', datasetId, readingIndex, source }.
 */
export default function ReadingHighlightLayer({ resultLayers }) {
  const { selection } = useSelection();
  const { current: map } = useMap();
  const feature = useMemo(
    () => (isReadingSelectionFor(selection, selection?.datasetId)
      ? findReadingFeature(resultLayers, selection.datasetId, selection.readingIndex) : null),
    [selection, resultLayers],
  );
  const fromPanel = selection?.source === 'pseudosection';

  useEffect(() => {
    if (!feature || !fromPanel || !map) return;
    const [lon, lat] = feature.geometry.coordinates;
    const bounds = typeof map.getBounds === 'function' ? map.getBounds() : null;
    const inView = bounds && lon >= bounds.getWest() && lon <= bounds.getEast() && lat >= bounds.getSouth() && lat <= bounds.getNorth();
    if (!inView) map.easeTo({ center: [lon, lat], duration: 400 });
  }, [feature, fromPanel, map, selection?.at]);

  if (!feature) return null;
  const data = { type: 'FeatureCollection', features: [{ type: 'Feature', properties: {}, geometry: feature.geometry }] };
  return (
    <Source id="pseudosection-reading-hl" type="geojson" data={data}>
      <Layer id="pseudosection-reading-hl-halo" type="circle" paint={{ 'circle-radius': 13, 'circle-color': '#f472b6', 'circle-opacity': 0.25 }} />
      <Layer id="pseudosection-reading-hl-ring" type="circle" paint={{
        'circle-radius': 8, 'circle-color': 'rgba(0,0,0,0)', 'circle-stroke-color': '#f472b6', 'circle-stroke-width': 2.5,
      }} />
    </Source>
  );
}
